import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class FlightsBookingServicesComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    flightBookingDetails: api.FlightBookingDetails;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    get productsForServicesStep() {
        return this.reservation.products.filter(({ product }) =>
            product.stepNumber === 2 && product.flightId == this.reservation.selectedFlightIdForProducts || product.stepNumber === 2 && product.flightId == null
        );
    }

    get stepTwoBrands() {
        return this.reservation.brandedProductKits ? this.reservation.brandedProductKits.find((brands) =>
            brands.stepOnForm === 2 && brands.kitTarget !== 'AdditionalPopup'
        ) : undefined;
    }

    mounted() {
        const productsRocket = [...this.productsForServicesStep.map((product) => product.product)];
        if (this.stepTwoBrands && this.stepTwoBrands.products.length) {
            this.stepTwoBrands.products.forEach((brand) => {
                const productByBrand = this.reservation.products.find((product) => brand.id && product.product.id === brand.id);
                if (productByBrand) {
                    productsRocket.push(productByBrand.product);
                }
            });
        }
        new api.RetailRocket().orderFormStepOpened({
            flightKey: api.RetailRocketCL.flightKey,
            stepNumber: 2,
            products: productsRocket,
            bookingSessionId: this.flightBookingDetails.bookingSessionId,
            email: this.reservation.contacts.email
        });
    }

    onGoBack() {
        this.$emit('back');
    }

    onProductDetails(product: flights.ProductModel) {
        this.$emit('product-details', product);
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        this.$emit('product-selection-change', product, value);
    }
    
    onProductPackageSelectionChange(product, value, from){
        this.$emit('on-product-package-selection-change', product, value, from);
    }

    onServiceBrandChange(product: api.Product, prevProduct: api.Product) {
        this.$emit('service-brand-change', product, prevProduct);
    }

    onFlightTerms() {
        if (this.reservation.selectedFlight) {
            this.$emit('flight-terms', this.reservation.selectedFlight.uniqueId);
        }
    }

    onSubmit() {
        this.$emit('submit');
    }
}
